import { useState, useEffect, useRef, RefObject, createRef } from "react";
import { useForm } from "react-hook-form";
import { DEFAULT_DATA_TABLE_LIMIT, PAGE_Limit } from "../../../../utils/config";
import TextField from "../../../ui/TextField";
import commonStyles from "../../../features/DataTable.module.scss";
import styles from "./ApplicantCourseDataTable.module.scss";

const ApplicantCourseDataTable = ({
  attendance,
  tableData,
  register,
  setValue,
  errors,
  currentPage,
  setCurrentPage,
}) => {
  // ソート項目
  const [sortBy, setSortBy] = useState(null);
  // 昇順フラグ
  const [sortAscending, setSortAscending] = useState(true);
  // 1ページの件数
  const [limit, setLimit] = useState(DEFAULT_DATA_TABLE_LIMIT);
  // テーブルデータ

  // ヘッダーのチェックボックスuseRef
  const headerCkRef = useRef(null);
  // チェックボックスuseRef
  const recordCkRefs = useRef([]);
  // 当選状況useRef
  const recordLsRefs = useRef([]);
  // 未受講・受講中・受講済みuseRef
  const recordAsRefs = useRef([]);
  // 取得単位数useRef
  const recordAuRefs = useRef([]);
  // 出席情報更新フラグ値useRef
  const recordUaRefs = useRef([]);
  // 出席情報useRef
  const recordAdRefs = useRef([]);

  // 見出しリンククリック
  const handleTableHeaderClick = (clickedField) => {
    if (clickedField === sortBy)
      setSortAscending((sortAscending) => !sortAscending);
    setSortBy(clickedField);
  };

  // ページクリック
  const handlePageClick = (page) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    setCurrentPage(page);
  };

  // 表示件数変更
  const handleLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(1);
  };

  // ソート
  let sortedData = tableData;
  if (sortBy == "name_link") {
    // リンクデータ用ソート処理
    sortedData = tableData.slice().sort((a, b) => {
      const a_sort = a[sortBy].props.children;
      const b_sort = b[sortBy].props.children;
      const sort = a_sort.localeCompare(b_sort);
      return sortAscending ? sort : -sort;
    });
  } else if (sortBy === "acquisition_unit" || sortBy === "id") {
    // 単位数ソート処理(値でソート)
    sortedData = tableData.slice().sort((a, b) => {
      const sort = a[sortBy] - b[sortBy];
      return sortAscending ? sort : -sort;
    });
  } else if (sortBy) {
    // 通常ソート処理
    sortedData = tableData.slice().sort((a, b) => {
      const a_sort = String(a[sortBy]);
      const b_sort = String(b[sortBy]);
      const sort = a_sort.localeCompare(b_sort);
      return sortAscending ? sort : -sort;
    });
  }

  const maxPageNum = Math.ceil(sortedData.length / Number(limit));
  // 表示開始件数
  const offset = (currentPage - 1) * limit;
  sortedData = sortedData.slice(offset, offset + Number(limit));

  // 表示件数form/to
  const from = offset + 1;
  const to = offset + sortedData.length;

  // 表示データ件数分のuseRef作成
  sortedData.forEach((_, index) => {
    // チェックボックス
    recordCkRefs.current[index] = createRef();
    // 当選状況
    recordLsRefs.current[index] = createRef();
    // 未受講・受講中・受講済み
    recordAsRefs.current[index] = createRef();
    // 取得単位数
    recordAuRefs.current[index] = createRef();
    // 出席情報更新フラグ値
    recordUaRefs.current[index] = createRef();
    // 出席情報
    recordAdRefs.current[index] = Array();
    {
      Array.from({ length: 15 }).map(
        (_, i) => (recordAdRefs.current[index][i] = createRef()),
      );
    }
  });

  // ヘッダーチェックボックスイベント
  const onChangeCk = () => {
    const checked = headerCkRef.current.checked;
    // 全行のチェックボックスを操作
    recordCkRefs.current.map(
      (ref, index) => (
        (ref.current.checked = checked),
        setValue("is_update_attendance_" + index, "1")
      ),
    );
  };

  // レコードごとの入力/選択フィールドイベント
  const onChangeRecordField = (index, element, is_attendance = false) => {
    // 対象行のチェックボックスをチェック
    recordCkRefs.current[index].current.checked = true;
    // 見た目はチェック状態だがそのままだとValueがPOSTされないのでsetValue実行
    setValue("is_update_" + index, "1");
    // 背景色変更
    element.className = element.className + " " + styles.is_change;
    // 出席情報の場合
    if (is_attendance) {
      // 出席情報更新フラグ値設定
      setValue("is_update_attendance_" + index, "1");
    }
  };

  // ページネーション
  const Pagination = () => {
    const getChildNode = (page, label) => {
      return (
        <li
          onClick={() => handlePageClick(page)}
          className={`page-item ${currentPage === label ? "active" : ""} ${
            commonStyles.datatable__pagination__item
          }`}
        >
          <div class="page-link"> {label} </div>
        </li>
      );
    };
    if (maxPageNum === 0) {
      //検索結果0件
      return <></>;
    }

    const disp_range = 3;

    const child = [];
    if (currentPage > disp_range + 1) {
      child.push(getChildNode(1, 1));
      child.push(getChildNode(currentPage - 1, "<"));
    }
    for (let i = currentPage - disp_range; i <= currentPage + disp_range; i++) {
      if (i > 0 && i <= maxPageNum) {
        child.push(getChildNode(i, i));
      }
    }
    if (currentPage < maxPageNum - disp_range) {
      child.push(getChildNode(currentPage + 1, ">"));
      child.push(getChildNode(maxPageNum, maxPageNum));
    }
    child.push();

    return (
      <nav className={commonStyles.datatable__pagination}>
        <ul className={commonStyles.datatable__pagination}>{child}</ul>
      </nav>
    );
  };

  /*ページング件数表示 */
  const RecordNum = () => {
    if (tableData.length > 0) {
      return (
        <span
          className={commonStyles.datatable__recordnum}
        >{`${from} - ${to}件 / ${tableData.length}件`}</span>
      );
    } else {
      return <span className={commonStyles.datatable__recordnum}>{`0件`}</span>;
    }
  };

  // レコードごとのチェックボックス
  const returnCkField = (index) => {
    const { ref, ...rest } = register("is_update_" + index);
    return (
      <input
        id={"is_update_" + index}
        type="checkbox"
        value="1"
        ref={(e) => {
          recordCkRefs.current[index].current = e;
          ref(e);
        }}
        {...rest}
      />
    );
  };

  // 取得単位数
  const returnAuField = (index, value) => {
    const { ref, ...rest } = register("acquisition_unit_" + index);

    return (
      <input
        className={"input " + styles.movetable__acquisition_unit_input}
        type="number"
        min="0"
        max="99999"
        ref={(e) => {
          recordAuRefs.current[index].current = e;
          ref(e);
        }}
        {...rest}
        onChange={(e) => onChangeRecordField(index, e.target)}
      />
    );
  };

  // 出席・欠席ドロップダウンリスト
  const returnAttendanceSelect = (index, num, value) => {
    const { ref, ...rest } = register("attendance_" + index + "_" + (num + 1));

    return (
      <select
        name={"attendance_" + index + "_" + (num + 1)}
        ref={(e) => {
          recordAdRefs.current[index][num].current = e;
          ref(e);
        }}
        {...rest}
        onChange={(e) => {
          onChangeRecordField(index, e.target);
          // 全15個の出席情報からvalue=1：出席の個数をカウント
          let attendanceCount = 0;
          for (let i = 0; i < 15; i++) {
            const attendanceElement = recordAdRefs.current[index][i]?.current;
            if (attendanceElement && attendanceElement.value === "1") {
              attendanceCount++;
            }
          }
          // カウントした個数を取得単位数に設定
          setValue("acquisition_unit_" + index, String(attendanceCount));
          // 取得単位数フィールドの背景色も変更
          const auElement = recordAuRefs.current[index].current;
          if (auElement && !auElement.className.includes(styles.is_change)) {
            auElement.className = auElement.className + " " + styles.is_change;
          }
        }}
      >
        <option value="0">▼選択</option>
        {attendance.map((option) => (
          <option value={String(option.value)}>{option.label}</option>
        ))}
      </select>
    );
  };

  // 一覧データセット
  const tableDataSet = (tableData) => {
    tableData.map((d, i) => {
      // 講座ID
      setValue("course_id_" + i, d.course_id);
      // 排他用日時
      setValue("updated_at_" + i, d.updated_at);
      // 取得単位数
      setValue("acquisition_unit_" + i, d.acquisition_unit);
      // 出席情報
      {
        Array.from({ length: 15 }).map((_, num) =>
          setValue(
            "attendance_" + i + "_" + (num + 1),
            d["attendance" + (num + 1)],
          ),
        );
      }
    });
  };

  // 固定部分
  const fixTable = (sortedData) => {
    const tableMeata = [{ key: "name_link", label: "講座名" }];
    const fixSortedData = [];
    sortedData.forEach(function (sData) {
      fixSortedData.push({
        course_id: sData.course_id,
        name_link: sData.name_link,
      });
    });
    return (
      <div className={styles.fixtable}>
        <table class={styles.responsivetable}>
          <thead>
            <tr className={styles.fixtable__thead_tr}>
              <th className={styles.fixtable__ckbox}>
                <input
                  type="checkbox"
                  value="1"
                  ref={headerCkRef}
                  onChange={onChangeCk}
                />
              </th>
              {tableMeata.map((field) => (
                <th
                  onClick={() => handleTableHeaderClick(field.key)}
                  className={styles["fixtable__" + field.key]}
                >
                  {field.label}{" "}
                  {field.key === sortBy ? (sortAscending ? "▲" : "▼") : ""}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {fixSortedData.map((rData, index) => (
              <tr className={styles.fixtable__tbody_tr}>
                <td className={styles.fixtable__ckbox}>
                  {returnCkField(index)}
                  <div hidden>
                    <input
                      className="input"
                      type="text"
                      name={"course_id_" + index}
                      defaultValue={rData.course_id}
                      {...register("course_id_" + index, {})}
                    ></input>
                  </div>
                </td>
                <td>
                  <div className={styles.fixtable__name_link_td}>
                    {rData.name_link}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // スクロール移動部分
  const moveTable = (sortedData) => {
    var tableMeata = [];

    tableMeata = [
      { key: "lottery_status", label: "当選状況" },
      { key: "univ_id", label: "大学ID" },
      { key: "id", label: "申込者ID" },
      { key: "how_apply", label: "申込方法" },
      { key: "attendance_status", label: "未受講・受講中・受講済み" },
      { key: "attendance_updated_date", label: "出欠情報更新日時" },
      { key: "acquisition_unit", label: "取得単位数" },
    ];

    var attendanceMeata = [
      { key: "attendance1", label: "1回目" },
      { key: "attendance2", label: "2回目" },
      { key: "attendance3", label: "3回目" },
      { key: "attendance4", label: "4回目" },
      { key: "attendance5", label: "5回目" },
      { key: "attendance6", label: "6回目" },
      { key: "attendance7", label: "7回目" },
      { key: "attendance8", label: "8回目" },
      { key: "attendance9", label: "9回目" },
      { key: "attendance10", label: "10回目" },
      { key: "attendance11", label: "11回目" },
      { key: "attendance12", label: "12回目" },
      { key: "attendance13", label: "13回目" },
      { key: "attendance14", label: "14回目" },
      { key: "attendance15", label: "15回目" },
    ];

    var moveSortedData = [];
    sortedData.forEach(function (sData) {
      moveSortedData.push({
        course_id_: sData.course_id_,
        updated_at: sData.updated_at,
        lottery_status: sData.lottery_status,
        univ_id: sData.univ_id,
        id: sData.id,
        how_apply: sData.how_apply,
        attendance_status: sData.attendance_status,
        attendance_updated_date: sData.attendance_updated_date,
        acquisition_unit: sData.acquisition_unit,
        attendance1: sData.attendance1,
        attendance2: sData.attendance2,
        attendance3: sData.attendance3,
        attendance4: sData.attendance4,
        attendance5: sData.attendance5,
        attendance6: sData.attendance6,
        attendance7: sData.attendance7,
        attendance8: sData.attendance8,
        attendance9: sData.attendance9,
        attendance10: sData.attendance10,
        attendance11: sData.attendance11,
        attendance12: sData.attendance12,
        attendance13: sData.attendance13,
        attendance14: sData.attendance14,
        attendance15: sData.attendance15,
      });
    });

    return (
      <div className={styles.movetable}>
        <table class={styles.responsivetable}>
          <thead>
            <tr className={styles.movetable__thead_tr}>
              {tableMeata.map((field) => (
                <th
                  onClick={() => handleTableHeaderClick(field.key)}
                  className={styles["movetable__" + field.key]}
                >
                  {field.label}{" "}
                  {field.key === sortBy ? (sortAscending ? "▲" : "▼") : ""}
                </th>
              ))}
              {attendanceMeata.map((field) => (
                <th
                  onClick={() => handleTableHeaderClick(field.key)}
                  className={styles.movetable__attendance}
                >
                  {field.label}{" "}
                  {field.key === sortBy ? (sortAscending ? "▲" : "▼") : ""}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {moveSortedData.map((rData, index) => (
              <tr className={styles.movetable__tbody_tr}>
                <TextField
                  type="hidden"
                  errors={errors}
                  register={register}
                  name={"updated_at_" + index}
                />
                <td>{rData.lottery_status}</td>
                <td>{rData.univ_id}</td>
                <td>{rData.id}</td>
                <td>{rData.how_apply}</td>
                <td>{rData.attendance_status}</td>
                <td>{rData.attendance_updated_date}</td>
                <td>{returnAuField(index, rData.acquisition_unit)}</td>
                {Array.from({ length: 15 }).map((_, i) => (
                  <td>
                    {returnAttendanceSelect(
                      index,
                      i,
                      rData["attendance" + (i + 1)],
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className={commonStyles.datatable}>
      <RecordNum />
      <select
        name="limit"
        value={limit}
        onChange={(e) => handleLimitChange(e.target.value)}
        className={commonStyles.datatable__dispnum}
      >
        {PAGE_Limit.map((el) => (
          <option value={el.value}>{el.label}</option>
        ))}
      </select>
      <Pagination />
      <div class={styles.tablearea}>
        {fixTable(sortedData)}
        {moveTable(sortedData)}
      </div>
      <Pagination />
      {tableDataSet(sortedData)}
    </div>
  );
};

export default ApplicantCourseDataTable;
